/**
 * LanguageRow - "we speak your language" trust strip under the hero.
 *
 * v11.2: one row of flag chips + native language names, so a visitor scanning
 * the fold sees their own script before scrolling (conversion trust signal for
 * the KO/TW/JA markets — the extension's primary audiences).
 *
 * v11.2.1: full-color flags (the grayscale version read as "dead" — the Japan
 * flag especially). Chip span is flex-center + img block so the flag fills the
 * frame exactly (an inline <img> sits on the text baseline and leaves a white
 * gap under it — the "misaligned / white margin" the user saw).
 *
 * Links: `ko`/`zh-TW`/`ja` go to their prerendered indexable shells (/ko/, /zh-TW/, /ja/);
 * the rest use `?lang=` (detected by LandingI18n). No i18n keys needed — each
 * language name is written in its own script, identical across all 8 tables.
 */

const LANGUAGES = [
  { flag: 'us', label: 'English', href: '/' },
  { flag: 'kr', label: '한국어', href: '/ko/' },
  { flag: 'ja', label: '日本語', href: '/ja/' },
  { flag: 'cn', label: '简体中文', href: '/?lang=zh' },
  { flag: 'tw', label: '繁體中文', href: '/zh-TW/' },
  { flag: 'es', label: 'Español', href: '/?lang=es' },
  { flag: 'fr', label: 'Français', href: '/?lang=fr' },
  { flag: 'de', label: 'Deutsch', href: '/?lang=de' },
] as const

export function LanguageRow() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 sm:gap-x-5">
      {LANGUAGES.map((lang) => (
        <a
          key={lang.flag}
          href={lang.href}
          className="inline-flex items-center gap-1.5 rounded-md px-1 py-0.5 text-[11px] sm:text-xs text-on-surface-variant transition-colors hover:text-ink focus-visible:outline-2 focus-visible:outline-primary"
        >
          {/* Flag chip — decorative (name text is the accessible label).
              flex-center + block img: fills the frame edge-to-edge, no
              baseline gap, no white margin. */}
          <span className="flex h-4 w-6 shrink-0 items-center justify-center overflow-hidden rounded-[3px] ring-1 ring-black/10">
            <img
              src={`/landing/flags/${lang.flag}.svg`}
              alt=""
              className="block h-full w-full object-cover"
            />
          </span>
          <span>{lang.label}</span>
        </a>
      ))}
    </div>
  )
}
